import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchUser } from "services/api/users";
import { AuthState } from "slices/auth/reducer";
import { ERROR } from "types";
import { User } from "types/users";
import { getErrorMessage } from "utils/helpers";

export const fetchUserData = createAsyncThunk<User, string, {rejectValue: string}>(
    'user/fetch',
    async (id: string, {getState, rejectWithValue}) => {
        const state = getState() as {auth: AuthState};
        try {
            const user = await fetchUser(state.auth.selectedAgencyId!, id);
            return user;
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
)